import React from 'react';
import { useRightPanel } from '../app/layout/RightPanel';
import Avatar from '../components/Avatar';
import AvatarStack from '../components/AvatarStack';
import Button, { IconButton } from '../components/Button';
import Tooltip from '../components/Tooltip';
import { BEACON_TOPIC_MEMBERS } from '../constants/onboarding';
import type { DocumentType } from '../graphql/generated/gql';
import { gql } from '../graphql/generated/gql';
import memberIcon from '../icons/non-prefilled/16x16/member.svg';
import TutorialBeacon from '../onboarding/tutorial/TutorialBeacon';
import UserDetailPreviewPopOver from '../user/UserDetailPreviewPopOver';
import * as styles from './TopicActionButtons.module.scss';
import TopicUsersPanel from './users/TopicUsersPanel';

const USERS_FRAGMENT = gql(`
  fragment TopicActionButtons_users on User {
    id
    ...AvatarStack_users
  }
`);

interface TopicActionButtonsProps {
  topicUsers: DocumentType<typeof USERS_FRAGMENT>[];
  limit: number;
}

const TopicActionButtons = ({ topicUsers, limit }: TopicActionButtonsProps) => {
  const { openRightPanel } = useRightPanel();
  const onShowUsers = () => openRightPanel(<TopicUsersPanel />);

  return (
    <div className={styles.container}>
      <TutorialBeacon id={BEACON_TOPIC_MEMBERS}>
        <div>
          {topicUsers.length > 0 ? (
            <Button onClick={onShowUsers}>
              <AvatarStack
                items={topicUsers}
                limit={limit}
                countOverflowTooltip="View members"
                size={30}
              >
                {(user, options) => (
                  <UserDetailPreviewPopOver
                    userId={user.id}
                    placement="top-start"
                    hoverDelay="fast"
                  >
                    <Avatar user={user} size={options.size} />
                  </UserDetailPreviewPopOver>
                )}
              </AvatarStack>
            </Button>
          ) : (
            <Tooltip content="View members">
              <IconButton
                className={styles.membersButton}
                onClick={onShowUsers}
                aria-label="View members"
              >
                {memberIcon}
              </IconButton>
            </Tooltip>
          )}
        </div>
      </TutorialBeacon>
    </div>
  );
};

export default TopicActionButtons;
